export default __webpack_public_path__ + "static/media/israelexperience.5c3fb19c.svg";